import React, { Component } from "react";
// import { settingsStart, getSettingsSuccess, settingsFailure } from '../../../../../../../src/redux/actions/settings'

// Ajax Methods
import ajaxMethods from "../../../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../../../api/ajax-endpoints";

// Forms
import {
  LiquidationAccountColumns,
  reOrderTableData,
} from "../../../../../../redux/actions/loans";
import LiquidationChannelForm from "./LiquidationChannelView/LiquidationChannelForm";
import LiquidationChannelView from "./LiquidationChannelView/LiquidationChannelView";
import { appInsights } from "../../../../../../config/appInsights";

export default class LiquidationChannelSettings extends Component {
  //State
  state = {
    loading: false,
    liquidationChannelOptions: [],
    selectedLiquidationId: "",
    bankId: "",
    accountNumber: "",
    bankOptionsList: [],
    repayEdit: false,
    bankName: "",
    error: "",
    accountName: "",
    accountLoading: false,
    selectedLiquidationIdSearch: "",
    LiquidationChannelList: [],
    channelAccountsDetails: [],
    reOrderedTableData: [],
    loadingAccount: false,
  };

  // Life Cycle Hooks
  componentDidMount() {
    this.getLiquidationChannels();
    this.getBankList();
  }

  // Component Methods
  editModeHandler = (target) => {
    this.setState({ bankId: "", accountNumber: "" });
    let selectedForm = target.dataset["form"];
    // if(this.state.selectedLiquidationId){
    //     this.getDisbursementChannelDetails()

    // }

    this.setState({
      [`${selectedForm}Edit`]: true,
    });
  };

  cancelUpdateHandler = (target) => {
    let selectedForm = target.dataset["form"];

    this.setState({
      [`${selectedForm}Edit`]: false,
      [`${selectedForm}FormCopy`]: this.state[`${selectedForm}Form`],
      accountName: "",
    });
  };

  handleRepaySelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      repayEdit: false,
    });
  };
  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // fetch liquidation channel list
  getLiquidationChannels = () => {
    ajaxMethods
      .get(ajaxEndpoints.ALL_LIQUIDATION_CHANNELS)
      .then((response) => {
        let LiquidationChannelLists = [];
        if (response.data.length > 0) {
          LiquidationChannelLists = [...response.data];
        } else {
          LiquidationChannelLists = [
            {
              code: 0,
              productCategoryName: "No Categories Yet",
            },
          ];
        }
        const LiquidationChannelListOption = LiquidationChannelLists.map(
          (ecosystem, index) => {
            const { id, name } = ecosystem;
            return (
              <option key={index} id={id} value={id}>
                {name}
              </option>
            );
          }
        );

        this.setState({
          liquidationChannelOptions: LiquidationChannelListOption,
          LiquidationChannelList: LiquidationChannelLists,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
      });
  };

  // fetch accounts for a specific disburse channel
  getLiquidationChannelAccounts = () => {
    this.setState({
      loading: true,
      channelAccountsDetails: [],
      reOrderedTableData: [],
    });
    ajaxMethods
      .get(
        ajaxEndpoints.ALL_LIQUIDATION_CHANNELS +
          `/${this.state.selectedLiquidationIdSearch}/accounts`
      )
      .then((response) => {
        this.setState({ loading: false });

        if (response.status_code === 200 || response.status_code === 201) {
          if (response.data) {
            this.setState({ channelAccountsDetails: response.data });
            const reOrderedTableData = reOrderTableData(
              LiquidationAccountColumns,
              response.data
            );

            this.setState({ reOrderedTableData: reOrderedTableData });
          } else {
            this.setState({ channelAccountsDetails: [] });
          }
        } else {
          this.setState({ channelAccountsDetails: [] });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
      });
  };

  //get bank list
  getBankList = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let bankList = response.data;
          const bankOptionsList = bankList.map((data, index) => {
            return (
              <option value={data.id} key={index}>
                {data.name}
              </option>
            );
          });
          this.setState({ bankOptionsList: bankOptionsList });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
      });
  };
  //create disbursement channel accounts
  onCreateLiquidationChannelAccount = () => {
    this.setState({ loadingAccount: true });
    const { selectedLiquidationId, bankId, accountNumber, accountName } =
      this.state;
    const Repay = {
      channel_id: Number(selectedLiquidationId),
      bank_id: Number(bankId),
      account_number: accountNumber,
      account_name: accountName,
    };

    ajaxMethods
      .post(ajaxEndpoints.ADD_LIQUIDATION_CHANNEL_ACCOUNTS, Repay)
      .then((response) => {
        this.setState({ loadingAccount: false });
        let message = "";
        if (
          response.data.status_code === 200 ||
          response.status_code === 200 ||
          response.data.status_code === 201 ||
          response.status_code === 201
        ) {
          message = response.data.message;
          this.props.onSetToast("success", message);
          this.setState({ repayEdit: false });
        } else if (response.status === 400) {
          message = response.data.message;
          this.props.onSetToast("error", message);
        } else {
          this.props.onSetToast(
            "warning",
            "Unable to connect to Advancly services"
          );
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
        this.props.onSetToast(
          "warning",
          "Unable to connect to Advancly services"
        );
      });
  };
  // validate account number
  onAccountNumberInput = (e) => {
    this.setState({ error: false, accountName: "" });
    let number = e.target.value;
    if (this.state.bankId === "") {
      this.setState({ error: `Please select a bank` });
      return;
    }

    this.setState({ accountNumber: number }, () => {
      this.getBankCode();
      if (number.length === 10 && !this.state.accountLoading) {
        this.setState({ accountLoading: true });

        //validate account number and bank name
        let data = {
          bank_code: this.state.bankCode,
          bank_account_num: number,
        };
        this.validateAccount(data);
      }
    });
  };
  // fetch product category list
  getBankCode = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST + `?bank_id=${this.state.bankId}`)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let res = response.data[0];
          this.setState({ bankCode: res.code });
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
      });
  };
  validateAccount = (data) => {
    ajaxMethods
      .post(ajaxEndpoints.VALIDATE_ACCOUNT_NUMBER, data)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.setState({
            accountName: response.data.bank_account_name,
            accountLoading: false,
          });
          // response.json()
          //   .then(res => {
          //   })
        } else if (response.status === 400) {
          this.setState({
            error: response.data.message,
            accountLoading: false,
          });
        }
        if (response.status >= 500) {
          this.setState({
            error: "Unable to connect to Advancly services.",
            accountLoading: false,
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LiquidationChannelSettings.js",
          },
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: false,
    });
  };

  render() {
    const { systemFormCopy } = this.state;

    return (
      <div className="GlobalSettings col-sm-12 mt-30">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <LiquidationChannelForm
              inputs={systemFormCopy}
              onEditMode={this.editModeHandler}
              onCancelUpdate={this.cancelUpdateHandler}
              onInputChange={this.handleChange}
              repayEdit={this.state.repayEdit}
              liquidationChannelOptions={this.state.liquidationChannelOptions}
              selectedLiquidationId={this.state.selectedLiquidationId}
              bankId={this.state.bankId}
              error={this.state.error}
              accountLoading={this.state.accountLoading}
              accountName={this.state.accountName}
              accountNumber={this.state.accountNumber}
              bankOptionsList={this.state.bankOptionsList}
              handleOptionSelect={this.handleOptionSelect}
              handleRepaySelect={this.handleRepaySelect}
              onCreateLiquidationChannelAccount={
                this.onCreateLiquidationChannelAccount
              }
              onAccountNumberInput={this.onAccountNumberInput}
              loadingAccount={this.state.loadingAccount}
            />
          </div>
          <div className="col-lg-8 col-md-6 col-sm-12">
            <LiquidationChannelView
              selectedLiquidationIdSearch={
                this.state.selectedLiquidationIdSearch
              }
              handleOptionSelect={this.handleOptionSelect}
              LiquidationChannelLists={this.state.LiquidationChannelList}
              channelAccountsDetails={this.state.channelAccountsDetails}
              reOrderedTableData={this.state.reOrderedTableData}
              loading={this.state.loading}
              onSearch={this.getLiquidationChannelAccounts}
            />
          </div>
        </div>
      </div>
    );
  }
}
